import React from 'react';
import styled from 'styled-components';
// import { Lock, ArrowLeft } from 'lucide-react';
import { FaArrowLeft, FaLock } from 'react-icons/fa';

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  width: 100vw;
  background: #f3f5f7;
  padding: 20px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  margin: 0;
  overflow: hidden;
  position: fixed;
  top: 0;
  left: 0;
`;

const ContentWrapper = styled.div`
  text-align: center;
  animation: fadeIn 0.5s ease-out;
  max-width: 600px;

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 80px;
  height: 80px;
  border-radius: 16px;
  background: linear-gradient(135deg, rgba(0, 82, 204, 0.1) 0%, rgba(0, 82, 204, 0.05) 100%);
  border: 2px solid rgba(0, 82, 204, 0.2);
  margin: 0 auto 32px;

  svg {
    width: 48px;
    height: 48px;
    color: #0052cc;
  }
`;

const Title = styled.h1`
  font-size: 36px;
  font-weight: 700;
  color: #1a1a1a;
  margin: 0 0 16px 0;
  letter-spacing: -0.5px;
`;

const Description = styled.p`
  font-size: 18px;
  color: #4a5568;
  margin: 0 0 12px 0;
  line-height: 1.6;
  font-weight: 500;
`;

const DetailText = styled.p`
  font-size: 15px;
  color: #718096;
  margin: 16px 0 0 0;
  line-height: 1.6;
  max-width: 500px;
  margin-left: auto;
  margin-right: auto;
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: 16px;
  margin-top: 40px;
  flex-direction: column;
  align-items: center;

  @media (min-width: 480px) {
    flex-direction: row;
    justify-content: center;
  }
`;

const Button = styled.button`
  padding: 12px 28px;
  border-radius: 8px;
  font-size: 15px;
  font-weight: 600;
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  min-width: 150px;

  &:hover {
    transform: translateY(-2px);
  }

  &:active {
    transform: translateY(0);
  }
`;

const PrimaryButton = styled(Button)`
  background: linear-gradient(135deg, #0052cc 0%, #0052cc 100%);
  color: white;
  box-shadow: 0 4px 16px rgba(0, 82, 204, 0.3);

  &:hover {
    background: linear-gradient(135deg, #0047b2 0%, #0047b2 100%);
    box-shadow: 0 8px 24px rgba(0, 82, 204, 0.4);
  }
`;

const SecondaryButton = styled(Button)`
  background: white;
  color: #0052cc;
  border: 2px solid #e2e8f0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);

  &:hover {
    background: #f8fafc;
    border-color: #cbd5e1;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  }
`;

export default function AccessDenied() {
  const handleGoBack = () => {
    window.history.back();
  };

  const handleContactSupport = () => {
    window.open('mailto:support@metamorphtech.com');
  };

  return (
    <Container>
      <ContentWrapper>
        <IconWrapper>
          <FaLock />
        </IconWrapper>
        <Title>Access Denied</Title>
        <Description>
          You don't have the required authority to view this page.
        </Description>
        <DetailText>
          If you believe this is an error or need access to this resource, please contact your administrator or support team for assistance.
        </DetailText>
        <ButtonGroup>
          <SecondaryButton onClick={handleGoBack}>
            <FaArrowLeft size={18} />
            Go Back
          </SecondaryButton>
          <PrimaryButton onClick={() => {}}>
            Contact Support
          </PrimaryButton>
        </ButtonGroup>
      </ContentWrapper>
    </Container>
  );
}